import React from "react";
import { Link, useLocation } from "react-router-dom";

const SidebarLinks = () => {
  const location = useLocation();

  const tabs = [
    {
      tab: "Manage My Account",
      descrption: [
        { label: "My Profile", to: "profile" },
        { label: "Address Book", to: "address" },
        { label: "My Payment Option", to: "payment" },
        // { label: "Lazmy Wallet", to: "wallet" },
      ],
    },
    {
      tab: "My Orders",
      descrption: [
        { label: "Orders History", to: "orders" },
        { label: "My Returns", to: "returns" },
        // { label: "My Cancellations", to: "cancellations" },
      ],
    },
    {
      tab: "My Reviews",
      descrption: [{ label: "My Wishlist & Followed Stores", to: "wishlist" }],
    },
    {
      tab: "Sell On Lazmy",
      descrption: [],
    },
  ];

  const username = sessionStorage.getItem("name");

  return (
    <div className="px-10">
      <p className="text-dark">
        <span className="text-capitalize">Hello, {username}</span>
      </p>
      <button className="btn btn-success rounded-30 fw-bold py-10 mt-20">
        Verified Account
      </button>
      {tabs.map((item, index) => (
        <div key={index} className="my-20 d-flex flex-column text-capitalize">
          <h6 className="text-dark text-xl fw-semibold font-heading-two">
            {item.tab}
          </h6>
          <div className="d-flex flex-column">
            {item.descrption &&
              item.descrption.map((link, idx) => (
                <Link
                  key={idx}
                  to={`/${link.to}`}
                  className={`mb-4 text-sm hover-text-decoration-underline ${
                    location.pathname.includes(link.to)
                      ? "text-primary fw-bold"
                      : "text-muted"
                  }`}
                >
                  {link.label}
                </Link>
              ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SidebarLinks;
